import { jsx as _jsx } from "react/jsx-runtime";
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { AllTasksPage, AllTasksBoard } from 'routes/vendor/lazy-imports';
// import { retryImportInsideRoutesDefinition } from 'utils/lazyWithRetry';
export const allTasksRoute = {
    path: ROUTE_PATHS.ALL_TASKS,
    element: /*#__PURE__*/ _jsx(SecureRoute, {
        children: /*#__PURE__*/ _jsx(AllTasksPage, {})
    })
};
export const allTaskBoardsPageRoute = {
    path: `${ROUTE_PATHS.ALL_TASKS}/${ROUTE_PATHS.PROJECT_TASKS_BOARD}`,
    element: /*#__PURE__*/ _jsx(SecureRoute, {
        children: /*#__PURE__*/ _jsx(AllTasksBoard, {})
    })
};
